import {lazy} from 'react';

export const routes = [
  {
        path: "/orders",
        exact: true,
        component: lazy(() => import("./components/Orders")),
        name: "Orders"
    },
    {
        path: "/orders/order/:id",
        exact: false,
        component: lazy(() => import("./components/OrderDetail")),
        name: "OrderDetail"
    }
];
